import React from "react";
import { Dropdown, Menu } from "antd";
import { ImportOutlined } from "@ant-design/icons";
import { useIsMobileWindowSize } from "Hooks/useWindowResize";
interface props {
    logoutCb: () => void;
}
function BackEmptyChat({ logoutCb }: props) {
    const isMobileSize = useIsMobileWindowSize();
    if (isMobileSize) {
        return (
            <div className="header-actions" key="actions">
                <Dropdown.Button
                    key={"HeaderMenu"}
                    trigger={["click"]}
                    overlay={
                        <Menu>
                            <Menu.Item key="6" onClick={() => logoutCb()} icon={<ImportOutlined />}>
                                Logout
                            </Menu.Item>
                        </Menu>
                    }
                />
            </div>
        );
    }
    return null;
}
export default BackEmptyChat;
